module.exports = __webpack_public_path__ + "static/media/ZPE.eea0bd15.pdf";